import { catch_error, get_user_info } from "./functions";
import axios from "axios";
import {
  validation_failed_border_color,
  validation_succcess_border_color,
} from "../consts/colors";

const hour = "ساعة";
const piece = "قطعة";

var recipe_name = "";
var recipe_ingredients = "";
var recipe_introduction = "";
var recipe_instructions = "";
var recipe_prep_time = 0;
var recipe_cook_time = 0;
var recipe_serving_count = 0;

var image_uploaded = 0;
var image_set = 0;

var preparation_in_minutes = true;
var cooking_in_minutes = true;

var recipe_category = "";
var recipe_images = [];
var positioned_images = 0;

function is_validated() {
  if (
    recipe_name !== "" &&
    recipe_ingredients !== "" &&
    recipe_introduction !== "" &&
    recipe_instructions !== "" &&
    recipe_prep_time !== 0 &&
    recipe_serving_count !== 0 &&
    image_uploaded === image_set
  ) {
    $("#new_recipe_submit").prop("disabled", false);
  } else {
    $("#new_recipe_submit").prop("disabled", true);
  }
}

function reset_inputs() {
  recipe_name = "";
  recipe_ingredients = "";
  recipe_introduction = "";
  recipe_instructions = "";
  recipe_prep_time = 0;
  recipe_cook_time = 0;
  recipe_serving_count = 0;
  image_uploaded = 0;
  image_set = 0;
  preparation_in_minutes = true;
  cooking_in_minutes = true;
  recipe_category = "";
  recipe_images = [];
  positioned_images = 0;
}

jQuery(document).ready(function ($) {
  $(document).on("change input focus", "#recipe-name", function (e) {
    recipe_name = e.target.value;
    if (e.target.value == "") {
      $("#recipe-name").css(
        "border",
        `0.1rem solid ${validation_failed_border_color}`
      );
    } else {
      $("#recipe-name").css(
        "border",
        `0.1rem solid ${validation_succcess_border_color}`
      );
    }
    is_validated();
  });

  $(document).on("click", "#popup-recipe .popup-recipe-close", function (e) {
    reset_inputs();
  });

  $(document).on("change input focus", "#recipe-ingredients", function (e) {
    recipe_ingredients = JSON.stringify(e.target.value);

    if (e.target.value == "") {
      $("#recipe-ingredients").css(
        "border",
        `0.1rem solid ${validation_failed_border_color}`
      );
    } else {
      $("#recipe-ingredients").css(
        "border",
        `0.1rem solid ${validation_succcess_border_color}`
      );
    }
    is_validated();
  });

  $(document).on("change input focus", "#recipe-comment", function (e) {
    recipe_introduction = JSON.stringify(e.target.value);

    if (e.target.value == "") {
      $("#recipe-comment").css(
        "border",
        `0.1rem solid ${validation_failed_border_color}`
      );
    } else {
      $("#recipe-comment").css(
        "border",
        `0.1rem solid ${validation_succcess_border_color}`
      );
    }

    is_validated();
  });

  $(document).on("change input focus", "#recipe-instructions", function (e) {
    recipe_instructions = JSON.stringify(e.target.value);

    if (e.target.value == "") {
      $("#recipe-instructions").css(
        "border",
        `0.1rem solid ${validation_failed_border_color}`
      );
    } else {
      $("#recipe-instructions").css(
        "border",
        `0.1rem solid ${validation_succcess_border_color}`
      );
    }

    is_validated();
  });

  $(document).on("change input focus", "#recipe_prep_time", function (e) {
    if (e.target.value !== "") {
      recipe_prep_time = parseInt(e.target.value);
    } else {
      recipe_prep_time = 0;
    }
    if (recipe_prep_time == 0) {
      $("#recipe_prep_time").css(
        "border",
        `0.1rem solid ${validation_failed_border_color}`
      );
    } else {
      $("#recipe_prep_time").css(
        "border",
        `0.1rem solid ${validation_succcess_border_color}`
      );
    }
    is_validated();
  });

  $(document).on("change input focus", "#recipe_cook_time", function (e) {
    recipe_cook_time = parseInt(e.target.value);
  });

  $(document).on("change input focus", "#recipe_serving_count", function (e) {
    if (e.target.value !== "") {
      recipe_serving_count = parseInt(e.target.value);
    } else {
      recipe_serving_count = 0;
    }

    if (recipe_serving_count == 0) {
      $("#recipe_serving_count").css(
        "border",
        `0.1rem solid ${validation_failed_border_color}`
      );
    } else {
      $("#recipe_serving_count").css(
        "border",
        `0.1rem solid ${validation_succcess_border_color}`
      );
    }
    is_validated();
  });

  $(document).on(
    "change",
    "input[type='radio'][name='recipe_prep_time']",
    function (e) {
      if (e.target.value == hour) {
        preparation_in_minutes = false;
      } else {
        preparation_in_minutes = true;
      }
    }
  );

  $(document).on(
    "change",
    "input[type='radio'][name='recipe_cook_time']",
    function (e) {
      if (e.target.value == hour) {
        cooking_in_minutes = false;
      } else {
        cooking_in_minutes = true;
      }
    }
  );

  $(document).on(
    "change",
    "input[type='radio'][name='recipe_serving']",
    function (e) {
      if (e.target.value == piece) {
        serving_in_person = false;
      } else {
        serving_in_person = true;
      }
    }
  );

  $(document).on(
    "change",
    ".radio--category input[type='radio']",
    function (e) {
      recipe_category = e.target.value;
      is_validated();
    }
  );

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  //upload Image
  function upload_image(image, id, index) {
    const url = `${savedSettings.api_url}/uploadPhoto`;
    let time = Date.now().toString();
    let body = {
      image: image,
      fileName: `${time}-submittedRecipe`,
    };
    axios
      .post(url, body, {
        headers: {
          "x-api-key": savedSettings.x_api_key,
          contentType: "application/json; charset=utf-8",
          Authorization: ` Bearer ${
            JSON.parse(localStorage.getItem("login_result"))?.access_token
          }`,
        },
      })
      .then((res) => {
        if (index) {
          recipe_images[index] = res.data.imageURL;
        } else {
          recipe_images.push(res.data.imageURL);
          $(`#${id}`).attr("data-image", recipe_images.length - 1);
        }
        image_uploaded++;
        is_validated();
        $(`#${id}_loading_container`).css("display", "none");
        $(`#${id}_remove_container`).css("display", "block");
      })
      .catch((err) => {
        catch_error(err);
        is_validated();
      });
  }

  //Set image for the view and upload it
  function setImage(id, new_id, file) {
    image_set++;
    is_validated();

    var index = null;
    if ($(`#${id}`).attr("data-image")) {
      index = $(`#${id}`).attr("data-image");
    }

    if (file) {
      //convert to base64
      const reader = new FileReader();
      reader.onloadend = () => {
        // use a regex to remove data url part
        const base64String = reader.result
          .replace("data:", "")
          .replace(/^.+,/, "");
        is_validated();
        upload_image(base64String, new_id, index);
      };
      reader.readAsDataURL(file);
      $(`#${new_id}_image`).css("opacity", "0");
      $(`#${new_id}_uploaded`).attr("src", URL.createObjectURL(file));
      $(`#${new_id}_uploaded`).css("opacity", "1");

      $(`#${id}`).val("").clone(true);
      $(`#${new_id}_loading_container`).css("display", "block");
    } else {
      $(`#${new_id}_image`).css("opacity", "1");
    }
  }

  //listen to image change then set and upload it
  $(document).on(
    "change",
    ".submit-recipe-images .add-recipe input[type='file']",
    function (e) {
      let file = e.target.files[0];
      let input_id = e.target.id;
      let new_id;

      if ($(`#${e.target.id}`).attr("data-image")) {
        new_id = input_id;
      } else {
        new_id = `${input_id.split("_")[0]}_${input_id.split("_")[1]}_${
          input_id.split("_")[2]
        }_${positioned_images + 1}`;

        if (file) {
          positioned_images++;
        }
      }

      setImage(e.target.id, new_id, file);
    }
  );

  //listen to image delete, remove it from the view and from the array and then push images to it's position
  $(document).on(
    "click",
    ".submit-recipe-images .uploaded-file-delete:not('.cookbook-remove')",
    function (e) {
      let clear_id = e.target.id;
      $(`#cookedBy_image_${positioned_images}_remove_container`).css(
        "display",
        "none"
      );

      let input_id = clear_id.replace("_remove", "");

      let data_image_number = $(`#${input_id}`).attr("data-image");

      $(`#${input_id}`).val("");

      let clear_id_array_index = parseInt(input_id.slice(-1));

      recipe_images.splice(clear_id_array_index - 1, 1);

      for (
        let i = parseInt(data_image_number) + 1;
        i <= positioned_images;
        i++
      ) {
        let current_field_id =
          clear_id.replace("_remove", "").slice(0, -1) + i.toString();
        let new_field_id =
          clear_id.replace("_remove", "").slice(0, -1) + (i + 1).toString();
        $(`#${current_field_id}`).attr(
          "data-id",
          $(`#${new_field_id}`).attr("data-id")
        );
        $(`#${current_field_id}_uploaded`).attr(
          "src",
          $(`#${new_field_id}_uploaded`).attr("src")
        );
        $(`#${current_field_id}`).val($(`#${new_field_id}`).val());
      }

      let last_element_id =
        clear_id.replace("_remove", "").slice(0, -1) +
        positioned_images.toString();
      $(`#${last_element_id}_uploaded`)
        .attr("src", " ")
        .attr("data-id", " ")
        .css("opacity", 0);
      $(`#${last_element_id}`).attr("data-id", " ");

      $(`#${last_element_id}_remove_container`).css("display", "none");

      $(`#${last_element_id}_image`).css("opacity", 1);

      positioned_images--;
      image_set--;
      image_uploaded--;
      is_validated();
    }
  );

  $(document).on("submit", "#add_recipe_form", function (e) {
    e.preventDefault();
    $("#new_recipe_submit").addClass("button--loading");

    const url = `${savedSettings.api_url}/submitRecipe`;

    let new_recipe_prep_time = recipe_prep_time;
    let new_recipe_cook_time = recipe_cook_time;

    if (!preparation_in_minutes) {
      new_recipe_prep_time = recipe_prep_time * 60;
    }

    if (!cooking_in_minutes) {
      new_recipe_cook_time = recipe_cook_time * 60;
    }

    let body = {
      title: recipe_name,
      description: recipe_introduction,
      ingredients: recipe_ingredients,
      preparation: recipe_instructions,
      imageURLs: recipe_images,
      preparationTimeInMinutes: parseInt(new_recipe_prep_time),
      cookingTimeInMinutes: parseInt(new_recipe_cook_time),
      totalServings: parseInt(recipe_serving_count),
      category: recipe_category,
    };

    axios
      .post(url, body, {
        headers: {
          "x-api-key": savedSettings.x_api_key,
          contentType: "application/json; charset=utf-8",
          Authorization: ` Bearer ${
            JSON.parse(localStorage.getItem("login_result"))?.access_token
          }`,
        },
      })
      .then((res) => {
        //~ UX Stuff

        $("#popup-recipe").removeClass("is-active");
        $("#recipe-submit-success").addClass("is-active");

        setTimeout(() => {
          $("#popup-recipe").remove();
          $("#recipe-submit-success").remove();
        }, 3000);
        get_user_info(false, false, true);

        //resetting default values
        recipe_name = "";
        recipe_ingredients = "";
        recipe_introduction = "";
        recipe_instructions = "";
        recipe_prep_time = 0;
        recipe_cook_time = 0;
        recipe_serving_count = 0;
        image_uploaded = 0;
        image_set = 0;
        preparation_in_minutes = true;
        cooking_in_minutes = true;
        recipe_category = "";
        recipe_images = [];
        positioned_images = 0;
      })
      .catch((err) => {
        catch_error(err);
        $("#new_recipe_submit").removeClass("button--loading");
      });
  });
});
